var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98216 9.01599C5.88776 9.10623 5.7741 9.17833 5.648 9.22796C5.5219 9.2776 5.38597 9.30375 5.24837 9.30484C5.11078 9.30593 4.97436 9.28193 4.84731 9.23429C4.72027 9.18666 4.60522 9.11637 4.50908 9.02764L0.903911 5.65031C0.800765 5.55923 0.718822 5.45051 0.662881 5.33052C0.606939 5.21054 0.578125 5.0817 0.578125 4.95155C0.578125 4.8214 0.606939 4.69257 0.662881 4.57258C0.718822 4.4526 0.800765 4.34388 0.903911 4.25279C1.09496 4.08281 1.35261 3.98751 1.62107 3.98751C1.88953 3.98751 2.14718 4.08281 2.33823 4.25279L5.2327 7.00124L11.6936 1.00357C11.8846 0.833591 12.1423 0.738281 12.4107 0.738281C12.6792 0.738281 12.9368 0.833591 13.1279 1.00357C13.3198 1.1836 13.427 1.42357 13.427 1.67321C13.427 1.92286 13.3198 2.16282 13.1279 2.34286L5.98216 9.01599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a445f117ede044c1dbfaa5d53fc13db5.svg";
export { ForwardRef as ReactComponent };